export const categories = [
  {
    slug: 'meirong-hufu',
    name: '美妆护肤',
    description: '精选国产美妆护肤品牌，天然成分，科学配方，为您的肌肤带来温和有效的呵护体验。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20skincare%20and%20cosmetics%20products%20displayed%20on%20minimal%20cream%20background%2C%20clean%20beauty%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20tones%2C%20professional%20ecommerce%20style&width=800&height=600&seq=cat-meirong&orientation=landscape',
    icon: 'ri-magic-line',
  },
  {
    slug: 'jiaju-shenghuo',
    name: '家居生活',
    description: '品质家居好物，从日常用品到家居装饰，让国产设计美学融入您的每一天。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20home%20decor%20and%20lifestyle%20products%20on%20minimal%20cream%20background%2C%20warm%20ambient%20lighting%2C%20clean%20interior%20photography%20style%2C%20professional%20ecommerce&width=800&height=600&seq=cat-jiaju&orientation=landscape',
    icon: 'ri-home-heart-line',
  },
  {
    slug: 'shuma-keji',
    name: '数码科技',
    description: '创新国产数码产品，前沿科技与人性化设计结合，用实力诠释中国智造。',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20Chinese%20tech%20gadgets%20and%20digital%20products%20on%20minimal%20cream%20background%2C%20modern%20product%20photography%20with%20clean%20lines%2C%20professional%20studio%20lighting&width=800&height=600&seq=cat-shuma&orientation=landscape',
    icon: 'ri-smartphone-line',
  },
  {
    slug: 'fushi-peishi',
    name: '服饰配饰',
    description: '融合东方美学与现代设计的服饰精品，甄选优质面料，展现独特国风魅力。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fashion%20and%20accessories%20displayed%20on%20minimal%20cream%20background%2C%20clean%20fashion%20photography%20with%20soft%20natural%20light%2C%20warm%20tones&width=800&height=600&seq=cat-fushi&orientation=landscape',
    icon: 'ri-t-shirt-line',
  },
  {
    slug: 'meishi-yinpin',
    name: '美食饮品',
    description: '地道中国味道，严选产地优质食材，传承经典工艺，品味舌尖上的国货精品。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Chinese%20food%20and%20beverage%20products%20on%20minimal%20cream%20background%2C%20gourmet%20food%20photography%20with%20warm%20lighting%2C%20clean%20composition&width=800&height=600&seq=cat-meishi&orientation=landscape',
    icon: 'ri-cup-line',
  },
  {
    slug: 'muying-yongpin',
    name: '母婴用品',
    description: '安全可靠的国产母婴产品，严苛质检标准，给妈妈和宝宝最安心的守护。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Chinese%20baby%20and%20maternity%20products%20on%20minimal%20cream%20background%2C%20soft%20and%20gentle%20product%20photography%20with%20warm%20natural%20light%2C%20clean%20style&width=800&height=600&seq=cat-muying&orientation=landscape',
    icon: 'ri-heart-pulse-line',
  },
];

export const products = [
  {
    id: 1,
    name: '花西子空气蜜粉',
    category: 'meirong-hufu',
    brand: '花西子',
    price: 149,
    rating: 4.8,
    reviews: 12680,
    description: '采用东方花卉精华配方，粉质细腻如空气般轻盈，控油持妆12小时，打造自然无瑕妆感。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20loose%20powder%20cosmetic%20product%20with%20floral%20design%20on%20minimal%20cream%20background%2C%20clean%20beauty%20product%20photography%20with%20soft%20natural%20lighting%2C%20professional%20ecommerce%20style&width=800&height=600&seq=prod-01&orientation=landscape',
    badge: '热卖爆款',
  },
  {
    id: 2,
    name: '完美日记小细跟口红',
    category: 'meirong-hufu',
    brand: '完美日记',
    price: 89,
    rating: 4.7,
    reviews: 25340,
    description: '灵感源自高跟鞋的优雅设计，丝滑质地一抹显色，多种色号满足不同场合需求。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20lipstick%20with%20sleek%20gold%20case%20on%20minimal%20cream%20background%2C%20clean%20beauty%20product%20photography%20with%20soft%20natural%20lighting%2C%20professional%20ecommerce%20style&width=800&height=600&seq=prod-02&orientation=landscape',
    badge: '明星同款',
  },
  {
    id: 3,
    name: '小米智能扫地机器人',
    category: 'shuma-keji',
    brand: '小米',
    price: 1299,
    rating: 4.9,
    reviews: 8950,
    description: 'LDS激光导航，4000Pa大吸力，智能规划路线，APP远程操控，解放双手的清洁利器。',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20white%20robot%20vacuum%20cleaner%20on%20minimal%20cream%20background%2C%20modern%20tech%20product%20photography%20with%20clean%20lines%2C%20professional%20studio%20lighting&width=800&height=600&seq=prod-03&orientation=landscape',
    badge: '科技新宠',
  },
  {
    id: 4,
    name: '华为FreeBuds Pro 3',
    category: 'shuma-keji',
    brand: '华为',
    price: 1199,
    rating: 4.8,
    reviews: 15670,
    description: '智慧动态降噪3.0，Hi-Res音质认证，超长续航，打造沉浸式听觉体验。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20wireless%20earbuds%20with%20charging%20case%20on%20minimal%20cream%20background%2C%20modern%20tech%20product%20photography%20with%20clean%20aesthetic%2C%20professional%20studio%20lighting&width=800&height=600&seq=prod-04&orientation=landscape',
    badge: '品质推荐',
  },
  {
    id: 5,
    name: '故宫文创千里江山杯',
    category: 'jiaju-shenghuo',
    brand: '故宫文创',
    price: 268,
    rating: 4.9,
    reviews: 3420,
    description: '以《千里江山图》为灵感，手工描金工艺，茶器与艺术品的完美结合。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20porcelain%20tea%20cup%20with%20gold%20landscape%20painting%20on%20minimal%20cream%20background%2C%20cultural%20art%20product%20photography%20with%20warm%20lighting&width=800&height=600&seq=prod-05&orientation=landscape',
    badge: '文创精品',
  },
  {
    id: 6,
    name: '野兽派香薰蜡烛',
    category: 'jiaju-shenghuo',
    brand: '野兽派',
    price: 359,
    rating: 4.7,
    reviews: 6780,
    description: '天然大豆蜡与植物精油调配，多款东方香型，营造温馨舒适的家居氛围。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20scented%20candle%20in%20minimal%20glass%20jar%20on%20cream%20background%2C%20warm%20lifestyle%20product%20photography%20with%20soft%20ambient%20lighting%2C%20clean%20composition&width=800&height=600&seq=prod-06&orientation=landscape',
    badge: '人气之选',
  },
  {
    id: 7,
    name: '李宁超轻20跑鞋',
    category: 'fushi-peishi',
    brand: '李宁',
    price: 599,
    rating: 4.8,
    reviews: 11230,
    description: '采用䨻科技中底，极致轻量化为跑者而生，国潮设计彰显运动时尚。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20sports%20running%20shoes%20on%20minimal%20cream%20background%2C%20clean%20sneaker%20product%20photography%20with%20dynamic%20lighting%2C%20professional%20ecommerce%20style&width=800&height=600&seq=prod-07&orientation=landscape',
    badge: '专业推荐',
  },
  {
    id: 8,
    name: '波司登极寒系列羽绒服',
    category: 'fushi-peishi',
    brand: '波司登',
    price: 1899,
    rating: 4.9,
    reviews: 4560,
    description: '90%白鹅绒填充，防风防水面料，专业级保暖，极地科考队同款品质。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20winter%20down%20jacket%20on%20minimal%20cream%20background%2C%20clean%20fashion%20product%20photography%20with%20soft%20lighting%2C%20professional%20ecommerce%20style&width=800&height=600&seq=prod-08&orientation=landscape',
    badge: '品质标杆',
  },
  {
    id: 9,
    name: '三只松鼠坚果礼盒',
    category: 'meishi-yinpin',
    brand: '三只松鼠',
    price: 168,
    rating: 4.7,
    reviews: 38920,
    description: '甄选全球优质坚果，独立小包装锁鲜，每日坚果科学配比，健康零食首选。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20mixed%20nuts%20gift%20box%20on%20minimal%20cream%20background%2C%20gourmet%20food%20product%20photography%20with%20warm%20natural%20lighting%2C%20clean%20composition&width=800&height=600&seq=prod-09&orientation=landscape',
    badge: '销量冠军',
  },
  {
    id: 10,
    name: '竹叶青峨眉高山绿茶',
    category: 'meishi-yinpin',
    brand: '竹叶青',
    price: 388,
    rating: 4.8,
    reviews: 2340,
    description: '产自峨眉山海拔800-1500米茶园，明前嫩芽手工采摘，清香回甘。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20green%20tea%20in%20premium%20packaging%20on%20minimal%20cream%20background%2C%20gourmet%20tea%20product%20photography%20with%20soft%20natural%20light%2C%20clean%20style&width=800&height=600&seq=prod-10&orientation=landscape',
    badge: '高端茗品',
  },
  {
    id: 11,
    name: 'Babycare婴儿湿巾',
    category: 'muying-yongpin',
    brand: 'Babycare',
    price: 59,
    rating: 4.8,
    reviews: 56780,
    description: 'EDI纯水工艺，无酒精无香精，加厚珍珠纹设计，呵护宝宝娇嫩肌肤。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20baby%20wipes%20packaging%20on%20minimal%20cream%20background%2C%20soft%20and%20gentle%20product%20photography%20with%20warm%20natural%20light%2C%20clean%20ecommerce%20style&width=800&height=600&seq=prod-11&orientation=landscape',
    badge: '妈妈首选',
  },
  {
    id: 12,
    name: '好孩子多功能婴儿推车',
    category: 'muying-yongpin',
    brand: '好孩子',
    price: 1299,
    rating: 4.7,
    reviews: 8900,
    description: '轻便折叠设计，可坐可躺，全罩式遮阳棚，避震系统平稳舒适。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20baby%20stroller%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20professional%20ecommerce%20style&width=800&height=600&seq=prod-12&orientation=landscape',
    badge: '口碑之选',
  },
];

export const articles = [
  {
    id: 1,
    title: '2025年国产美妆品牌崛起：从中国制造到中国创造',
    excerpt: '近年来，国产美妆品牌凭借对东方美学的深刻理解与科技创新，正在改写全球美妆产业格局。本文深度解析国产美妆品牌的崛起之路。',
    category: 'meirong-hufu',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20beauty%20products%20and%20cosmetics%20arranged%20artistically%20on%20minimal%20cream%20background%2C%20editorial%20photography%20style%20with%20soft%20natural%20light%2C%20clean%20composition&width=800&height=450&seq=article-01&orientation=landscape',
    date: '2025-03-15',
    readTime: '8分钟',
    author: '品质编辑团队',
    content: `近年来，国产美妆品牌正在经历一场前所未有的变革。从过去的"平价替代"到如今的"品质标杆"，国货美妆用实力证明了自身的价值。

花西子、完美日记、薇诺娜等品牌纷纷崛起，它们不仅在国内市场赢得消费者的青睐，更开始走向国际舞台。这些品牌的成功，源于对东方美学的深度挖掘和对产品品质的极致追求。

在产品研发上，国产美妆品牌越来越注重科技创新。许多品牌建立了自己的研发实验室，与国内外顶尖科研机构合作，将传统中草药智慧与现代生物科技相结合，开发出更加安全、有效的产品。

与此同时，国货美妆品牌在营销方式上也更加贴近年轻消费者。通过社交媒体、直播电商等新兴渠道，品牌与消费者建立了更直接的连接，让好产品能够更快地被市场认可。

我们有理由相信，未来的国产美妆品牌将不仅仅是"中国的"，更将成为"世界的"。`,
  },
  {
    id: 2,
    title: '国货科技品牌国际化：华为、小米的全球影响力',
    excerpt: '从智能手机到智能家居，国产科技品牌正以创新实力赢得全球用户的认可。华为和小米的成功故事，为中国品牌走向世界提供了范本。',
    category: 'shuma-keji',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20tech%20products%20smartphones%20and%20gadgets%20on%20minimal%20cream%20background%2C%20editorial%20photography%20style%20with%20clean%20aesthetic%2C%20professional%20lighting&width=800&height=450&seq=article-02&orientation=landscape',
    date: '2025-02-28',
    readTime: '10分钟',
    author: '科技观察员',
    content: `在全球科技产业的舞台上，华为和小米已经成为不可忽视的重要力量。这两家中国科技企业，用创新和品质书写了中国智造的传奇。

华为凭借在通信技术领域的深厚积累，将5G技术推向全球。从Mate系列到P系列，华为手机以其卓越的影像能力和创新设计，赢得了全球数亿用户的信赖。即使在面临严峻挑战的环境下，华为依然坚持研发投入，在操作系统、芯片设计等核心领域持续突破。

小米则以"让每个人都能享受科技的乐趣"为使命，通过极致性价比策略迅速打开市场。从小米手机到米家生态链，小米构建了一个庞大的智能生活产品矩阵，让科技真正走进千家万户。

这些国产科技品牌的成功，不仅仅是商业上的胜利，更是中国创新能力的集中体现。它们向世界证明：中国品牌完全有能力在全球高端市场占据一席之地。`,
  },
  {
    id: 3,
    title: '国潮家居新风尚：用东方美学装点现代生活',
    excerpt: '当传统东方美学遇上现代家居设计，会碰撞出怎样的火花？精选国潮家居好物，让您的家兼具文化底蕴与现代时尚。',
    category: 'jiaju-shenghuo',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20style%20home%20decor%20with%20porcelain%20and%20wooden%20elements%20on%20minimal%20cream%20background%2C%20editorial%20interior%20photography%20with%20warm%20ambient%20lighting&width=800&height=450&seq=article-03&orientation=landscape',
    date: '2025-01-20',
    readTime: '6分钟',
    author: '生活美学师',
    content: `在快节奏的现代生活中，越来越多的人开始追求家居空间的品质感和文化内涵。国潮家居应运而生，将东方美学的精髓融入日常生活。

故宫文创的家居系列，以馆藏文物为灵感，将千年文化的韵味带入现代家庭。从千里江山图的杯具到紫禁城的香薰，每一件产品都是可以使用的艺术品。

野兽派则以花艺美学为核心，推出一系列兼具颜值与品质的生活方式产品。其香薰蜡烛、家居织物等产品，用柔和的方式传递着东方人对美好生活的理解。

国潮家居的魅力在于，它不是简单的复古或符号堆砌，而是在深入理解传统文化精神的基础上，进行现代化的演绎。这种设计理念，正吸引着越来越多的年轻消费者。`,
  },
  {
    id: 4,
    title: '国产运动品牌进化论：从跟跑到领跑',
    excerpt: '安踏、李宁等国产运动品牌近年来在产品科技和设计创新上不断突破，它们是如何实现从跟随者到领跑者的转变？',
    category: 'fushi-peishi',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20sports%20apparel%20and%20sneakers%20on%20minimal%20cream%20background%2C%20editorial%20fashion%20photography%20with%20clean%20athletic%20aesthetic%2C%20professional%20lighting&width=800&height=450&seq=article-04&orientation=landscape',
    date: '2024-12-10',
    readTime: '7分钟',
    author: '运动产业观察',
    content: `曾几何时，国产运动品牌在国际巨头的阴影下艰难生存。但今天，安踏、李宁已经成为全球运动用品市场的重要玩家。

李宁品牌以创始人李宁的体育精神为内核，将中国传统文化元素与现代运动科技巧妙融合。"中国李宁"系列的推出，不仅引领了国潮风尚，更让世界看到了中国运动品牌的设计实力。

在产品科技方面，李宁自主研发的䨻科技中底材料，在回弹性能和轻量化方面达到了国际领先水平。安踏则通过收购FILA、始祖鸟母公司亚玛芬体育等国际品牌，构建了多品牌矩阵。

国产运动品牌的崛起告诉我们：只要坚持品质和创新，中国品牌完全有能力在全球竞争中脱颖而出。对消费者而言，选择国货运动品牌不再是"退而求其次"，而是真正的高品质之选。`,
  },
  {
    id: 5,
    title: '寻味中国：那些值得骄傲的国产食品品牌',
    excerpt: '从零食到饮品，从传统老字号到新兴网红品牌，国产食品正在用品质和创意重新定义"中国味道"。',
    category: 'meishi-yinpin',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Chinese%20snacks%20and%20tea%20products%20arranged%20artistically%20on%20minimal%20cream%20background%2C%20editorial%20food%20photography%20with%20warm%20natural%20lighting&width=800&height=450&seq=article-05&orientation=landscape',
    date: '2024-11-05',
    readTime: '5分钟',
    author: '美食探索者',
    content: `中国拥有世界上最丰富的美食文化，而国产食品品牌正在将这份文化底蕴转化为高品质的产品体验。

三只松鼠用互联网思维重新定义了坚果零食行业。从原料产地直采到智能化生产线，从趣味包装到个性化服务，三只松鼠让吃坚果变成了一种时尚的生活方式。

竹叶青则代表着中国茶文化的传承与创新。作为高端绿茶品牌，竹叶青坚持在峨眉山核心产区种植，严格控制采摘标准和制作工艺，让每一杯茶都呈现出最纯正的中国味道。

这些国产食品品牌的共同特点是对品质的极致追求。它们深知，在食品行业，安全与品质是永恒的生命线。也正是这份坚守，让国产食品品牌赢得了越来越多消费者的信任。`,
  },
  {
    id: 6,
    title: '国产母婴品牌：用爱心与责任守护每一个家庭',
    excerpt: '母婴产品关乎下一代的健康成长，国产母婴品牌以严苛的品质标准和持续的创新投入，赢得了中国妈妈的信任。',
    category: 'muying-yongpin',
    image: 'https://readdy.ai/api/search-image?query=Soft%20and%20gentle%20baby%20care%20products%20on%20minimal%20cream%20background%2C%20editorial%20photography%20with%20warm%20and%20tender%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-06&orientation=landscape',
    date: '2024-09-22',
    readTime: '6分钟',
    author: '育儿专家团',
    content: `母婴用品的安全性和品质，是每一位父母最关心的问题。值得欣慰的是，一批优秀的国产母婴品牌正在用实力证明：中国制造同样可以做到最好。

Babycare作为国产母婴品牌的代表，将"为新生"作为品牌使命。从一片小小的湿巾开始，Babycare坚持使用医药级EDI纯水，确保产品对宝宝肌肤零刺激。这种对细节的极致关注，让Babycare赢得了数千万妈妈的信任。

好孩子则用数十年的行业积淀，在婴儿推车、安全座椅等大件产品上持续创新。其产品不仅符合中国标准，更拿到了欧盟、美国等国际认证，真正做到了"全球品质，中国制造"。

选择国产母婴品牌，不仅仅是支持国货，更是选择了一份经过严格检验的安全与品质保障。`,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '李晓梅',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20on%20minimal%20cream%20background%2C%20warm%20and%20friendly%20expression%2C%20clean%20headshot%20photography%20with%20soft%20natural%20lighting&width=200&height=200&seq=avatar-01&orientation=squarish',
    role: '美妆博主',
    content: '自从开始关注国产精品后，我发现很多国货的品质完全不输国际大牌，价格却更加亲民。花西子的蜜粉真的是我用过的最好用的定妆产品！',
    rating: 5,
  },
  {
    id: 2,
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20on%20minimal%20cream%20background%2C%20confident%20and%20friendly%20expression%2C%20clean%20headshot%20photography%20with%20soft%20natural%20lighting&width=200&height=200&seq=avatar-02&orientation=squarish',
    role: '科技公司产品经理',
    content: '华为和小米的产品生态让我彻底改变了对国货科技产品的印象。现在的国产科技产品，无论是设计还是性能，都达到了世界一流水平。',
    rating: 5,
  },
  {
    id: 3,
    name: '王芳',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20and%20caring%20Chinese%20woman%20portrait%20on%20minimal%20cream%20background%2C%20gentle%20motherly%20expression%2C%20clean%20headshot%20photography%20with%20soft%20natural%20lighting&width=200&height=200&seq=avatar-03&orientation=squarish',
    role: '两个孩子的妈妈',
    content: '作为妈妈，给孩子选产品我最看重安全性。Babycare和好孩子的产品让我很放心，品质确实过硬，已经推荐给身边的很多妈妈朋友了。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈思远',
    avatar: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20man%20portrait%20on%20minimal%20cream%20background%2C%20artistic%20and%20thoughtful%20expression%2C%20clean%20headshot%20photography%20with%20soft%20natural%20lighting&width=200&height=200&seq=avatar-04&orientation=squarish',
    role: '室内设计师',
    content: '故宫文创和野兽派的家居产品让我找到了设计灵感。东方美学与现代设计的融合，让这些国货精品散发出独特的魅力。',
    rating: 4,
  },
];

export const brandFeatures = [
  {
    icon: 'ri-shield-check-line',
    title: '严选品质',
    description: '每一款产品都经过严格筛选，从原料到工艺层层把关，确保符合高品质标准。',
  },
  {
    icon: 'ri-leaf-line',
    title: '源头直供',
    description: '与品牌官方深度合作，确保正品保障，让您买得放心用得安心。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '专业客服团队7×24小时在线，为您提供全方位的购物咨询与售后支持。',
  },
  {
    icon: 'ri-rotate-lock-line',
    title: '无忧退换',
    description: '支持7天无理由退换货，让每一次购物都毫无后顾之忧。',
  },
];

export const categoryNameMap: Record<string, string> = {
  'meirong-hufu': '美妆护肤',
  'jiaju-shenghuo': '家居生活',
  'shuma-keji': '数码科技',
  'fushi-peishi': '服饰配饰',
  'meishi-yinpin': '美食饮品',
  'muying-yongpin': '母婴用品',
};